export interface otsConfig {
  flowConfigId?: string;
  promptId?: string;
  externalData?: string;
  jobId?: string;
  [key: string]: string | undefined;
}

export enum FlowConfigIdType {
  Etoro = 'etoro',
  Vanilla = 'vanilla',
  Custom = 'custom',
  Prograd = 'prograd',
  SalaryFinance = 'salary-finance',
  Syndesi = 'syndesi',
  RiseupWL = 'riseup-wl',
}

export enum WhiteLabelFirmIdType {
  DefaultFirm = 'abc',
  DNS = 'dns',
}

export interface OtsFlowConfig {
  flowId: string;
  flowName: string;
  descopeFlowId?: string;
  signupPageFlow?: OtsFlowPart;
  connectAccountsFlow: OtsFlowPart;
  resultsPageFlow: OtsFlowPart;
  shouldRunLlm: boolean;
  createdAt: string; // Assuming DateString is a string type
  createdBy: string;
  updatedAt?: string | null;
  updatedBy?: string | null;
  isActive: boolean;
}

export interface OtsFlowPart {
  flowId: string;
  pageType: OtsPageType;
}

export enum OtsPageType {
  url = 'url',
  story = 'story',
}
